import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-record-selection',
  templateUrl: './record-selection.component.html',
  styleUrls: ['./record-selection.component.scss'],
  standalone: false
})
export class RecordSelectionComponent implements OnInit {
  @Input() records: any[][] = [];
  selectedIndex: number | null = null;
  selectedNested: { [recordIndex: number]: { [fieldId: string]: string } } = {};

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    // this.records = [
    //   [
    //     {
    //       "controlId": "additional_ques15",
    //       "apiResponseKeyValue": "WILLIAM J RUBENSTEIN"
    //     },
    //     {
    //       "controlId": "additional_ques16",
    //       "apiResponseKeyValue": null
    //     },
    //     {
    //       "controlId": "additional_ques13",
    //       "apiResponseKeyValue": "2023-05-31"
    //     },
    //     {
    //       "controlId": "additional_ques12",
    //       "apiResponseKeyValue": "310 MASSACHUSETTS AVE UNIT 1, ARLINGTON, MA 02474"
    //     },
    //     {
    //       "controlId": "additional_ques14",
    //       "apiResponseKeyValue": "2025-05-22"
    //     },
    //     {
    //       "controlId": "additional_ques17",
    //       "apiResponseKeyValue": "RACHEL E SAM"
    //     },
    //     {
    //       "controlId": "additional_ques18",
    //       "apiResponseKeyValue": null
    //     },
    //     {
    //       "controlId": "ctrl_buyers_parent",
    //       "apiResponseKeyValue": [
    //         [
    //           {
    //             "controlId": "additional_ques_b1",
    //             "apiResponseKeyValue": "Alice Johnson"
    //           },
    //           {
    //             "controlId": "additional_ques_b2",
    //             "apiResponseKeyValue": "10-02-1980"
    //           },
    //         ],
    //         [
    //           {
    //             "controlId": "additional_ques_b1",
    //             "apiResponseKeyValue": "Bob Smith"
    //           },
    //           {
    //             "controlId": "additional_ques_b2",
    //             "apiResponseKeyValue": "14-02-1985"
    //           }
    //         ]
    //       ]
    //     }
    //   ],
    //   [
    //     {
    //       "controlId": "additional_ques15",
    //       "apiResponseKeyValue": "John"
    //     },
    //     {
    //       "controlId": "additional_ques16",
    //       "apiResponseKeyValue": "Thomas"
    //     },
    //     {
    //       "controlId": "additional_ques13",
    //       "apiResponseKeyValue": "2023-05-24"
    //     },
    //     {
    //       "controlId": "additional_ques12",
    //       "apiResponseKeyValue": "New York, 10128"
    //     },
    //     {
    //       "controlId": "additional_ques14",
    //       "apiResponseKeyValue": "2025-05-20"
    //     },
    //     {
    //       "controlId": "additional_ques17",
    //       "apiResponseKeyValue": "Harvey"
    //     },
    //     {
    //       "controlId": "additional_ques18",
    //       "apiResponseKeyValue": "Arthur"
    //     },
    //     {
    //       "controlId": "ctrl_buyers_parent",
    //       "apiResponseKeyValue": [
    //         [
    //           {
    //             "controlId": "additional_ques_b1",
    //             "apiResponseKeyValue": "Dave"
    //           },
    //           {
    //             "controlId": "additional_ques_b2",
    //             "apiResponseKeyValue": "14-02-1990"
    //           }
    //         ],
    //         [
    //           {
    //             "controlId": "additional_ques_b1",
    //             "apiResponseKeyValue": "Luca"
    //           },
    //           {
    //             "controlId": "additional_ques_b2",
    //             "apiResponseKeyValue": "14-02-1995"
    //           }
    //         ]
    //       ]
    //     }
    //   ]
    // ]
    console.log('Records received in modal:', this.records);
  }


  confirmSelection() {
    if (this.selectedIndex !== null) {
      // Get selected record
      const selectedRecord = this.records[this.selectedIndex];

      // Deep clone so we don't mutate
      const enrichedRecord = JSON.parse(JSON.stringify(selectedRecord));

      // Ensure only the chosen nested option is kept
      enrichedRecord.forEach((field: any) => {
        if (Array.isArray(field.apiResponseKeyValue)) {
          const selectedValue =
            this.selectedNested[this.selectedIndex]?.[field.controlId] || null;

          if (selectedValue) {
            // Find the matching group
            const selectedGroup = field.apiResponseKeyValue.find((group: any[]) =>
              this.getGroupValue(group) === selectedValue
            );

            // Keep only that group
            field.apiResponseKeyValue = selectedGroup ? [selectedGroup] : [];
          } else {
            // If nothing selected, clear it
            field.apiResponseKeyValue = [];
          }
        }
      });
      console.log("enrichedRecord", enrichedRecord)
      this.modalCtrl.dismiss(enrichedRecord, 'confirm');
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  getGroupValue(group: any[]): string {
    return group.map(child => child.apiResponseKeyValue).join(' | ');
  }

  selectRecord(index: number) {
    if (this.selectedIndex !== index) {
      this.selectedNested = {}; // clear all previous radio selections
    }

    this.selectedIndex = index;
    console.log("Selected record:", index, this.records[index]);
  }

  onNestedSelect(recordIndex: number, fieldId: string, value: string) {
    if (!this.selectedNested[recordIndex]) {
      this.selectedNested[recordIndex] = {};
    }
    this.selectedNested[recordIndex][fieldId] = value;
  }
  isSelectionComplete(): boolean {
    // No card selected
    if (this.selectedIndex === null) {
      return false;
    }

    const record = this.records[this.selectedIndex];

    // Check if this record contains nested fields
    const hasNested = record.some((field: any) => Array.isArray(field.apiResponseKeyValue));

    if (hasNested) {
      // Require at least one nested radio value
      const selected = this.selectedNested?.[this.selectedIndex];
      return !!(selected && Object.values(selected).some(v => v !== null));
    }

    // If no nested structure, card selection is enough
    return true;
  }

}
